export enum LaunchHub88 {
  pt = "pt",
  es = "es",
  hu = "hu",
}
